import { useCallback } from 'react';

export const useUnitChange = (onChange, value) => {
  return {
    handleUnitChange: useCallback((unit, e) => {
      onChange({ ...value, [e.target.name]: unit });
    }, [onChange, value])
};
};
